<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="star icon"></i>
      {{ $t("rating") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img
          src="/images/icons/teacher_rating.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <!-- <h4 class="ui dividing header">{{ $t("basic information") }}</h4> -->
          <div class="fields">
            <div class="disabled four wide  field">
              <label for="">{{ $t("evaluated user") }}</label>
              <input type="text" :value="target_user_name" />
            </div>
            <div class="six wide field">
              <label for="">{{ $t("rating") }}</label>
              <input type="text" name="rating" v-model="rating" />
            </div>
            <div class="disabled six wide field">
              <label for="">{{ $t("date") }}</label>
              <input type="text" name="date" :value="selected_date" />
            </div>
          </div>
          <div class="field">
            <label>{{ $t("comment") }}</label>
            <textarea name="comment" rows="2" v-model="comment"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
      <div class="ui blue icon right labeled negative button">
        <i class="close icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, warning_toast } from "@/utils";
// import moment from "moment";
// import GenericModal from "@/components/GenericModal";
// import General from "./General";

export default {
  name: "RatingModal",
  components: {
    // "generic-modal": GenericModal,
    // General,
  },
  computed: {},
  props: {},
  data() {
    return {
      target_user_id: "",
      target_user_name: "",
      uuid: "",
      rating: "",
      selected_date: "",
      comment: "",
    };
  },
  methods: {
    show_modal(options) {
      let vm = this;
      if (options) {
        vm.target_user_id = options.target_user_id;
        vm.target_user_name = options.target_user_name;
        vm.uuid = options.uuid;
        vm.rating = options.startRating;
        vm.selected_date = options.info.dateStr;
        vm.comment = options.comment;
      }
      // console.log(options);
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            // console.log(vm.$refs);
            window.jQuery(vm.$refs.form).form("clear");

            vm.target_user_id = "";
            vm.ratings = [];
          },
          onShow() {},
        })
        .modal("show");
    },
    save() {
      let vm = this;
      let isValid = window.jQuery(vm.$refs.form).form("validate form");
      if (isValid) {
        local_api(vm, "post", "/teacher_rating/rating/do-save", {
          r: vm.rating,
          u: vm.target_user_id,
          d: vm.selected_date, // moment(info.date).format("YYYY-MM-DD"),
          i: vm.uuid,
          s: { comment: vm.comment },
        })
          .then(() => {
            vm.$emit("saved");
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    // show(rating) {
    //   let vm = this;
    //   if (rating) {
    //     // console.log("rating", rating);
    //     // if (vm.professor.user_id) {
    //     //   window
    //     //     .jQuery(vm.$refs.users_dropdown)
    //     //     .dropdown("set selected", vm.professor.user_id);
    //     // }
    //   }

    //   window
    //     .jQuery(vm.$refs.modal)
    //     .modal({
    //       onHide() {
    //         // console.log(vm.$refs);
    //         window.jQuery(vm.$refs.form).form("clear");

    //         vm.target_user_id = "";
    //         vm.ratings = [];
    //       },
    //       onShow() {},
    //     })
    //     .modal("show");
    //   // vm.$refs.general.init();
    // },
    remove() {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove rating?"), function() {
        local_api(vm, "post", "/teacher_rating/rating/do-delete", {
          u: vm.uuid,
        })
          .then(() => {
            // vm.$emit("deleted");
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch((err) => {
            error_toast(err);
          });
      });
    },
    dateClick(info) {
      let vm = this;
      if (!vm.target_user_id) warning_toast(vm.$t("first select user to rate"));
      else {
        let trgtEvnt = vm.ratings.find((rt) => {
          return rt.rating_date == info.dateStr;
        });
        let startRating = "";
        let uuid = null;
        if (trgtEvnt) {
          // console.log("trgtEvnt", trgtEvnt);
          startRating = trgtEvnt.scoring;
          uuid = trgtEvnt.uuid;
        }

        vm.$alertify.prompt(this.$t("enter rating"), startRating, function(
          element,
          value,
        ) {
          local_api(vm, "post", "/teacher_rating/rating/do-save", {
            r: value,
            u: vm.target_user_id,
            d: info.dateStr, // moment(info.date).format("YYYY-MM-DD"),
            i: uuid,
            s: {},
          })
            .then(() => {
              let api = vm.$refs.fullCalendar.getApi();
              api.refetchEvents();
            })
            .catch((err) => {
              vm.$alertify.error(JSON.stringify(err));
            });
        });
      }
    },
    eventClick(info) {
      let vm = this;

      let event = info.event;
      vm.$alertify.prompt(this.$t("enter rating"), event.title, function(
        element,
        value,
      ) {
        local_api(vm, "post", "/teacher_rating/rating/do-save", {
          r: value,
          u: vm.target_user_id,
          i: event.id,
          s: {},
        })
          .then(() => {
            let api = vm.$refs.fullCalendar.getApi();
            api.refetchEvents();
          })
          .catch((err) => {
            vm.$alertify.error(JSON.stringify(err));
          });
      });
    },
    events(fetchInfo, successCallback, failureCallback) {
      let vm = this;
      if (vm.target_user_id) {
        fetchInfo.rated_user = vm.target_user_id;
        local_api(
          vm,
          "post",
          "/teacher_rating/rating/do-get-own-rating",
          fetchInfo,
        )
          .then((response) => {
            // console.log("response", response);
            vm.ratings = response;
            let events = response.map((evt) => {
              return {
                id: evt.uuid,
                title: evt.scoring,
                start: evt.rating_date,
                end: evt.rating_date,
                modul_object: evt,
                // description: evt.setup.description,
                // editable: true,
                // startEditable: true,
                // durationEditable: true,
                // overlap: true,
                // color: evt.setup.color,
              };
            });
            successCallback(events);
          })
          .catch((err) => {
            console.error(err);
            failureCallback(err);
          })
          .finally(() => {});
      }
    },
  },
  created() {},
  mounted() {
    let vm = this;

    /**
     * Users
     */
    local_api(vm, "post", "/teacher_rating/rating/do-get-users")
      .then((users) => {
        // vm.users = user;

        let vls = users.map((i) => {
          return { value: i.user_id, name: i.username, stx: i };
        });
        window
          .jQuery(vm.$refs.users_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.target_user_id = value;

              let api = vm.$refs.fullCalendar.getApi();
              api.refetchEvents();
              // console.log(api);
            },
          });
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  updated: function() {},
  watch: {},
};
</script>
